import ReviewIcon from "@material-ui/icons/Comment";
import ReviewList from "./ReviewList";

const resource = {
    icon: ReviewIcon,
    list: ReviewList,

};
export default resource;
